import { useEffect, useState } from 'react';

type CommonPostMessagePropsType = {
  myChat: any;
  // chatType: any;
};

export function normalizePostMessage(message: any): string {
  if (message == null) {
    return '';
  }

  if (typeof message === 'string') {
    return message;
  }

  if (Array.isArray(message)) {
    return message.map((item) => normalizePostMessage(item)).join('');
  }

  if (typeof message === 'number' || typeof message === 'boolean') {
    return String(message);
  }

  if (typeof message === 'object') {
    return normalizePostMessage(
      message.chat_msg ?? message.message ?? message.text ?? ''
    );
  }

  return '';
}

function removeTags(message: any) {
  const string = normalizePostMessage(message);
  if (!string) {
    return [];
  }

  // let newstring = string
  //   ?.replace(/<[^>]*>/g, ' ')
  //   ?.replace(/\s{2,}/g, ' ')
  //   ?.trim();
  // let content = newstring?.split(/((?:#|@|https?:\/\/[^\s]+)[a-zA-Z]+)/);
  let content = string.trim().split(/((?:#|@)[A-Za-z0-9_-]+)/);
  let hashtag;

  return content?.map((word: any) => {
    if (word.startsWith('#')) {
      hashtag = word.replace('#', '');
      const encodedHashtag = encodeURIComponent(hashtag);
      return (
        `
          <a href='/disneyland/hash/${encodedHashtag}' onclick="event.stopPropagation();" style="color: blue; text-decoration: underline;">${word}</a>`
      );
    } else {
      return word;
    }
  });
}
export const CommonPostMessage: React.FC<CommonPostMessagePropsType> = ({
  myChat
  // chatType
}) => {
  const [newChat, setNewChat] = useState(normalizePostMessage(myChat));

  useEffect(() => {
    setNewChat(removeTags(myChat).join(''));
  }, [myChat]);

  return (
    <div
      className='commonPostDetailMsg'
      dangerouslySetInnerHTML={{ __html: newChat }}
    />
  );
};
